<script lang="ts">
    import RadioInput from "../atoms/RadioInput.svelte";

    export let options: Array<IRadioSelect>
    export let active: string;

    interface IRadioSelect {
        label: string;
        value: string;
    }
</script>
<div>
    {#each options as input (input.value)}
        <RadioInput label="{input.label}" slug="{input.value}" active="{(input.value === active)}" on:click={()=>active = input.value}/>
    {/each}
</div>
